import type { Cotizacion, Sitio, ResultadoCalculo, Vendedor } from "./types";
import { construirPdf } from "./contracts";
import { garantiasDelPdf } from "./garantias";
export interface Propuesta {
  numero: string;
  numeroOficial: string | null;
  etiqueta: string;
  sitios: Sitio[];
  registroId: string | null;
  revision: number | null;
}
export function letraPropuesta(indice: number): string {
  let n = indice + 1,
    letra = "";
  while (n > 0) {
    n--;
    letra = String.fromCharCode(65 + (n % 26)) + letra;
    n = Math.floor(n / 26);
  }
  return letra;
}
export function snapshotPropuesta(c: Cotizacion): Propuesta {
  return {
    numero: c.numero,
    numeroOficial: c.numeroOficial ?? null,
    etiqueta: c.etiquetaPropuesta ?? "PROPUESTA A",
    sitios: c.sitios,
    registroId: c.registroId,
    revision: c.revision,
  };
}
export function cotizacionesPropuestas(
  c: Cotizacion,
  propuestas: Propuesta[],
): Cotizacion[] {
  if (!propuestas.length) return [c];
  return propuestas.map((p) =>
    p.numero === c.numero
      ? c
      : {
          ...c,
          numero: p.numero,
          numeroOficial: p.numeroOficial,
          etiquetaPropuesta: p.etiqueta,
          sitios: p.sitios,
          registroId: p.registroId,
          revision: p.revision,
        },
  );
}
export function construirComparativo(
  resultados: { c: Cotizacion; r: ResultadoCalculo }[],
  v: Vendedor,
) {
  if (resultados.length < 2)
    throw new Error("El comparativo requiere al menos dos propuestas.");
  const primero = construirPdf(resultados[0].c, resultados[0].r, v);
  return {
    numero_cotizacion: resultados[0].c.numeroBaseOficial ?? "BORRADOR",
    cliente: primero.cliente,
    condiciones: primero.condiciones,
    formato_pdf: primero.formato_pdf,
    mostrar_valor_unitario: primero.mostrar_valor_unitario,
    incluir_garantias: primero.incluir_garantias,
    // Las generales una vez (son de todas las propuestas); las de sitio y
    // pieza de cada una, con la propuesta delante del sitio.
    garantias: resultados.flatMap(({ c }, i) =>
      garantiasDelPdf(c)
        .filter((g) => i === 0 || g.grupo !== null)
        .map((g) =>
          g.grupo === null
            ? g
            : { ...g, grupo: `${c.etiquetaPropuesta} · ${g.grupo}` },
        ),
    ),
    // Para la firma del comercial al pie del PDF comparativo.
    vendedor_nombre: primero.vendedor_nombre,
    vendedor_firma: primero.vendedor_firma,
    propuestas: resultados.map(({ c, r }) => {
      const p = construirPdf(c, r, v);
      return {
        etiqueta: c.etiquetaPropuesta,
        subtotal_sin_iva: p.subtotal_sin_iva,
        iva_incluido: p.iva_incluido,
        iva_pct: p.iva_pct,
        iva_monto: p.iva_monto,
        subtotal_sin_iva_bruto: p.subtotal_sin_iva_bruto,
        descuento_general_pct: p.descuento_general_pct,
        descuento_general_monto: p.descuento_general_monto,
        total_general: p.total_general,
        sitios: p.sitios,
      };
    }),
  };
}
